import { type ReactNode } from 'react';

import styled from 'styled-components';

import CloseIcon from '@mui/icons-material/Close';

import IconButton from 'shared/atoms/IconButton';

const InnerTooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TextContainer = styled.div`
  width: 90%;
  padding-top: 8px;
  font-weight: 400;
  font-size: 0.9rem;
`;

interface TitleComponentProps {
  title?: string | ReactNode;
  onClose: () => void;
}

const TitleComponent = ({ title, onClose }: TitleComponentProps) => {
  return (
    <InnerTooltipWrapper>
      <IconButton
        ariaLabel="close"
        icon={CloseIcon}
        onClick={onClose}
        sx={{ marginLeft: 'auto' }}
        theme="light"
        type="transparent"
      />
      <TextContainer>{title}</TextContainer>
    </InnerTooltipWrapper>
  );
};

export default TitleComponent;
export type { TitleComponentProps };
